import React from 'react';
import { useTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import { Accordion } from '@ff-os/shared-react/components/accordion/Accordion';
import { AccordionField } from '@ff-os/shared-react/components/accordion/partials/AccordionField';
import { ExpandableAccordionMenu } from '@ff-os/shared-react/components/accordion/partials/ExpandableAccordionMenu';
import { useMobile } from '@ff-os/shared-react/hooks/useMobile';
import { useToggle } from '@ff-os/shared-react/hooks/useToggle';
import { GiftPdpState } from '@ff-scene-plugins/gift-redux/store';
import { PrefabHeading } from '@ff-scene-plugins/gift-shared/GiftSceneOptions';
import { selectPrefabHeading } from '../../_redux-scene';
import { PrefabPickerGrid } from './PrefabPickerGrid';
import styles from './PrefabPickerAccordion.module.scss';

const _PrefabPickerAccordion = ({ heading }: Props) => {

    const [isOpen, toggleOpen] = useToggle(true);
    const isMobile = useMobile();

    const { t } = useTranslation();
    const translations: { [Key in PrefabHeading]: string } = {
        'layouts': t('windows.prefabs.heading.layouts'),
        'designs': t('windows.prefabs.heading.designs')
    };

    return (
        <Accordion>
            <AccordionField onClick={toggleOpen} active={isOpen}>
                {translations[heading]}
            </AccordionField>
            <ExpandableAccordionMenu active={isOpen} initialHeight={300} className={styles.container}>
                <PrefabPickerGrid isMobile={isMobile} />
            </ExpandableAccordionMenu>
        </Accordion>
    );
};

type Props = {
    heading: PrefabHeading;
};

const mapStateToProps = (state: GiftPdpState) => ({
    heading: selectPrefabHeading(state)
});

export const PrefabPickerAccordion = connect(
    mapStateToProps
)(_PrefabPickerAccordion);